import {
  CHART_CONFIG,
  clearModalParameter,
  clearSinceBeginning,
  collapseComplexTable,
  COLLAPSIBLE_TABLES_DETAILS,
  COLLAPSIBLE_TABLES_SUBQUESTION_DETAILS,
  convertPDFsAndZip,
  CSV_QUESTION_DETAILS,
  CURRENT_ACTIVE_PAGE,
  downloadCSV,
  downloadProgramCSV,
  downloadProjectsPdfArchive,
  expandComplexTable,
  EXPANDED_QUESTION_LIST,
  getChartConfig,
  loadQuestionGroupData,
  loadQuestionGroupDataModal,
  loadQuestionGroups,
  LATEST_SURVEY_TEMPLATE_NAME,
  LATEST_SURVEY_TEMPLATE_VERSION,
  loadTableDetails,
  loadTableQuestionDetails,
  loadTableSubquestionDetails,
  MISSING_QUESTION_GROUPS,
  MODAL_SELECT_PARAMETERS,
  MODAL_SELECT_QUESTION_LIST,
  PROGRAM_INSTANCE_FOREIGN_IDS,
  PROJECT_COUNT,
  propertyChange,
  QUESTION_GROUPS,
  QUESTION_LIST,
  removeCsvQuestionDetails,
  removeTableDetails,
  removeTableQuestionDetails,
  SECTIONS,
  setModalParameter,
  setSinceBeginning,
  SINCE_BEGINNING,
  START_CONVERSION,
  SURVEYS_BY_REPORTING_YEAR,
  TEMPLATES
} from "../../../../ducks/collapsibleTableChart";
import { getTimeFacetForEvaluation, LABEL, labelChange, RECEIVED_TIME_FACET } from "../../../../ducks/report";
import {
  FUNDING_AREA_LIST,
  SELECTED_FUNDING_AREA,
  SELECTED_PROGRAM,
  SELECTED_PROGRAM_INSTANCE
} from "../../../../ducks/fundingArea";

import CollapsibleTableChart from "./CollapsibleTableChart";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

const mapStateToProps = (state) => {
  return {
    currentActivePage: state.collapsibleTableChart[CURRENT_ACTIVE_PAGE],
    sections: state.collapsibleTableChart[SECTIONS],
    collapsibleTablesDetails: state.collapsibleTableChart[COLLAPSIBLE_TABLES_DETAILS],
    collapsibleTablesSubquestionDetails: state.collapsibleTableChart[COLLAPSIBLE_TABLES_SUBQUESTION_DETAILS],
    timeFacet: state.report[RECEIVED_TIME_FACET],
    questionGroups: state.collapsibleTableChart[QUESTION_GROUPS],
    missingQuestionGroups: state.collapsibleTableChart[MISSING_QUESTION_GROUPS],
    projectCount: state.collapsibleTableChart[PROJECT_COUNT],
    latestSurveyTemplateName: state.collapsibleTableChart[LATEST_SURVEY_TEMPLATE_NAME],
    latestSurveyTemplateVersion: state.collapsibleTableChart[LATEST_SURVEY_TEMPLATE_VERSION],
    surveysByReportingYear: state.collapsibleTableChart[SURVEYS_BY_REPORTING_YEAR],
    questionList: state.collapsibleTableChart[QUESTION_LIST],
    modalSelectQuestionList: state.collapsibleTableChart[MODAL_SELECT_QUESTION_LIST],
    chartConfig: state.collapsibleTableChart[CHART_CONFIG],
    modalSelectParameters: state.collapsibleTableChart[MODAL_SELECT_PARAMETERS],
    csvQuestionDetails: state.collapsibleTableChart[CSV_QUESTION_DETAILS],
    fundingAreaList: state.fundingArea[FUNDING_AREA_LIST],
    selectedFundingArea: state.fundingArea[SELECTED_FUNDING_AREA],
    selectedProgram: state.fundingArea[SELECTED_PROGRAM],
    selectedProgramInstance: state.fundingArea[SELECTED_PROGRAM_INSTANCE],
    programInstanceForeignIds: state.collapsibleTableChart[PROGRAM_INSTANCE_FOREIGN_IDS],
    label: state.report[LABEL],
    expandedQuestionList: state.collapsibleTableChart[EXPANDED_QUESTION_LIST],
    startConversion: state.collapsibleTableChart[START_CONVERSION],
    surveyTemplates: state.collapsibleTableChart[TEMPLATES],
    sinceBeginning: state.collapsibleTableChart[SINCE_BEGINNING]
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      propertyChange,
      labelChange,
      loadTableDetails,
      removeTableDetails,
      removeCsvQuestionDetails,
      getTimeFacetForEvaluation,
      getChartConfig,
      loadTableQuestionDetails,
      removeTableQuestionDetails,
      loadQuestionGroups,
      loadQuestionGroupData,
      loadQuestionGroupDataModal,
      setModalParameter,
      expandComplexTable,
      collapseComplexTable,
      downloadCSV,
      downloadProgramCSV,
      downloadProjectsPdfArchive,
      loadTableSubquestionDetails,
      convertPDFsAndZip,
      clearModalParameter,
      setSinceBeginning,
      clearSinceBeginning
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(CollapsibleTableChart);
